import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { FilterSessionService } from './filter-session.service';

@Injectable({
  providedIn: 'root'
})
export class FilterRouteSyncService {
  private initialized = false;

  constructor(
    private router: Router,
    private userService: UserLoginService,
    private filterSessionService: FilterSessionService
  ) {}

  init(): void {
    if (this.initialized) {
      return;
    }

    this.initialized = true;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.handleRouteChange());
  }

  private handleRouteChange(): void {
    const routePath = this.router.url.split('?')[0];
    const user = this.userService.getCurrentUser();

    if (!user) {
      return;
    }

    const tree = this.router.parseUrl(this.router.url);
    const currentParams = tree.queryParams || {};
    const hasParams = Object.keys(currentParams).length > 0;

    if (hasParams) {
      // Query params exist → Save to session
      this.filterSessionService.save({
        routePath,
        userId: user.userId.toString(),
        companyId: user.companyId,
        branchId: user.loggedInBranchId
      }, currentParams);
    } else {
      // No query params → Try to restore from session
      const saved = this.filterSessionService.load({
        routePath,
        userId: user.userId.toString(),
        companyId: user.companyId,
        branchId: user.loggedInBranchId
      });

      if (saved && Object.keys(saved).length > 0) {
        // Inject saved params back to URL
        this.router.navigate([], {
          queryParams: saved,
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }
      // else: No params, no saved data → Fresh page, do nothing
    }
  }
}
